import InputData from "../InputData";

export default class OutlineInputData extends InputData {

    url = null
    path = null
    pathToStaticImage = null
    fieldId = null
    color = null

    constructor(url, data = {}) {
        super(data)
        this.url = url
        this.setData(data)
    }

    setData(data) {
        super.setData(data);
        ['url', 'fieldId', 'color', 'path', 'pathToStaticImage'].forEach((key) => {
            this[key] = data?.[key] !== undefined ? data[key] : this[key]
        })
    }

    getUrl(defVal = '') {
        return this.url || defVal
    }

    getColor() {
        return this.color || '#000000';
    }

    getPathStaticImage() {
        return this.pathToStaticImage || null;
    }
}